// extracted by mini-css-extract-plugin
export var legendIndicator = "_dc-1";
export var legendRight = "_dc-0";